import React from 'react'
import { MainPageBlockForm } from '../form/MainPageConfigFormState'

type CouponsBlockProps = {
  block: MainPageBlockForm
  onChange: (block: MainPageBlockForm) => void
}

export default function CouponsBlock ({
  block,
  onChange
}: CouponsBlockProps) {
  return (
    <div>
      <h4>Купоны</h4>
      <p>Блок отображает доступные купоны для пользователя. Дополнительные настройки не требуются.</p>
    </div>
  )
}